// extracted by mini-css-extract-plugin
export default {"editRecordContainer":"CreateRecord_editRecordContainer__mPK7D","editingHeader":"CreateRecord_editingHeader__oYbPZ"};